<template>
  <div class="extended-forms">
    <div class="view-block" v-if="loading">
      <div>
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      </div>
    </div>
    <div class="row" v-if="evaluation.evaluation_type_id == 1">
      <div class="col-lg-12">
        <h5 class="title_h5">Gestor Imediato</h5>
        <div class="card">
          <div class="card-content text-center desc_member">
            <div class="row">
              <div class="col-xs-2">
                <div class="avatar img_member">
                  <img :src="currentUser.avatar_url" alt="Circle Image" class="img-circle img-no-padding img-responsive">
                </div>
              </div>
              <div class="col-xs-10">
                <div class="pull-left name_member">
                  <span>
                    {{ currentUser.name }}
                  </span><br/><small>{{ currentUser.position.functional_classification.name }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <h5 class="title_h5">Colaborador</h5>
        <div class="card">
          <div class="card-content text-center desc_member">
            <div class="row">
              <div class="col-xs-2">
                <div class="avatar img_member"><img :src="evaluation.collaborator.avatar_url" alt="Circle Image" class="img-circle img-no-padding img-responsive"></div>
              </div>
              <div class="col-xs-10">
                <div class="pull-left name_member">
                  <span>
                    {{ evaluation.collaborator.name }}
                  </span><br/><small>{{ evaluation.collaborator.position.name }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- AVALIAÇÃO -->
    <div class="card card-av-desempenho">
      <div class="card-content">
        <div class="row">
          <div class="col-md-12">
            <h4 class="card-title">COMPETÊNCIAS</h4>
            <div class="row" v-for="(skill, index) in evaluation.collaborator.skills" :key="`skill-${index}`">
              <div class="col-md-12">
                <h6><b>{{ skill.name }}</b><br/><br/><small>{{ skill.description }}</small></h6>
                <div class="row">
                  <div class="col-sm-12">
                    <evaluation-answer @setEvaluationAnswer="setEvaluationAnswer" :evaluationWeight="evaluation.evaluation_weight" :skillId="skill.id"></evaluation-answer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br/><br/>
      </div>
    </div>
    <!-- end card --> 

    <div class="card card-av-desempenho">
      <div class="card-content">
        <div class="row">
          <div class="col-md-12">
            <h4 class="card-title">Entrega</h4>
            <small>Avaliar segundo a realidade atual (o desempenho das entregas realizadas) e não pela situação esperada (o potencial demonstrado). A avaliação só terá valor se as respostas refletirem as verdadeiras práticas e a performance apresentada pelo colaborador ao longo do último ano. ​Trata-se de uma “fotografia” das entregas em geral, considerando o que normalmente acontece. Ou seja, deve refletir a maioria das entregas e trabalhos resultados e não o “destaque de um único trabalho).​<br/><br/></small>
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-12">
                    <evaluation-delivery-answer @setEvaluationDeliveryAnswer="setEvaluationDeliveryAnswer"></evaluation-delivery-answer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br/><br/>
      </div>
    </div>
    <!-- end card --> 

    <div class="card card-av-desempenho" v-if="evaluation.evaluation_type_id == 3">
      <div class="card-content">
        <div class="row">
          <div class="col-md-12">
            <h4 class="card-title">Sua opinião</h4>
            <small>Deixe aqui sua mensagem sobre o seu desempenho durante este ciclo.​<br/><br/></small>
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-12">
                    <textarea
                      class="form-control"
                      rows="6"
                      placeholder="Escreva sua opinião aqui..."
                      v-model="evaluationOpenAnswer"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br/><br/>
      </div>
    </div>
        
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-content text-center">
            <button type="button" class="btn btn-wd btn-success btn-fill btn-rotate bt-end" @click="validEvaluation()">
              <span class="btn-label"><i class="ti-save"></i></span>
               Concluir Avaliação
            </button>
          </div>
        </div>
      </div>
    </div>    
  </div>
</template>
<script>
  import swal from 'sweetalert2'

  export default {
    mounted () {
      this.collaboratorId = this.$route.params.collaboratorId
      this.evaluationId = this.$route.params.evaluationId
      this.token = this.$route.params.token
      this.getCollaborator()
    },
    data () {
      return {
        token: null,
        evaluation: {},
        loading: true,
        evaluationAnswers: [],
        evaluationDeliveryAnswer: '',
        evaluationOpenAnswer: ''
      }
    },
    methods: {
      getCollaborator () {
        let url = '/collaborator/manager/collaborator-evaluation'
        axios.post(url, { token: this.token })
        .then((response) => {
          this.evaluation = response.data
          this.loading = false
        }).catch((error) => {
          this.loading = false
          if (error.response.status === 500) {
            this.setError('Error inesperado, tente novamente mais tarde.')
          } else {
            this.setError(error.response.data.error)
          }
        })
      },
      setError (message) {
        swal({
          title: 'Avaliação!',
          text: message,
          type: 'warning',
          showCancelButton: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          confirmButtonText: 'Voltar',
          buttonsStyling: false,
          allowOutsideClick: false,
          preConfirm: () => {
            return (new Promise((resolve, reject) => {
              resolve('OK')
            }))
          }
        }).then(() => {
          this.$router.push(`/avaliacao/equipe`)
        })
      },
      setEvaluationAnswer (answer) {
        let answers = this.evaluationAnswers.filter((element) => {
          if (element.skillId === answer.skillId) {
            return false
          } else {
            return true
          }
        })

        answers.push(answer)

        this.evaluationAnswers = answers
      },
      setEvaluationDeliveryAnswer (answer) {
        this.evaluationDeliveryAnswer = answer.answerValue
      },
      validEvaluation () {
        const countSkills = this.evaluation.collaborator.skills.length

        const selfAssignmentFlag = this.evaluation.evaluation_type_id === 3
          ? !!this.evaluationOpenAnswer
          : true

        if (this.evaluationAnswers.length === countSkills && !!this.evaluationDeliveryAnswer && selfAssignmentFlag) {
          swal({
            title: 'Você tem certeza!',
            html: 'Avaliação será Concluída.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Enviar Avaliação',
            buttonsStyling: false,
            preConfirm: () => {
              return this.sendEvaluationAnswer()
                .catch(error => {
                  let message = 'Não foi possível completar a requisição, tente novamente mais tarde.'
                  if (error.response.status !== 500) {
                    message = error.response.data.error
                  }
                  swal.showValidationError(message)
                  return Promise.reject(new Error(message))
                })
            }
          }).then(() => {
            // Define a mensagem de redirecionamento com base no tipo
            let redirectMessage = ''
            if (this.evaluation.evaluation_type_id === 1) {
              redirectMessage = 'você será redirecionado para o <b>Plano de Ação</b>'
            } else if (this.evaluation.evaluation_type_id === 3) {
              redirectMessage = 'você será redirecionado para a página de <b>Minhas Avaliações</b>'
            } else {
              redirectMessage = 'o processo será concluído'
            }

            swal({
              title: 'Avaliação Concluída!',
              html: `Avaliação do colaborador foi realizada com sucesso. <br> <small>${redirectMessage}</small>`,
              type: 'success',
              showCancelButton: false,
              confirmButtonClass: 'btn btn-success btn-fill',
              confirmButtonText: 'OK',
              buttonsStyling: false,
              allowOutsideClick: false,
              preConfirm: () => Promise.resolve('OK')
            }).then(() => {
              if (this.evaluation.evaluation_type_id === 1) {
                this.$router.push(`/avaliacao/formulario-resultado/${this.evaluation.id}/${this.collaboratorId}`)
              } else if (this.evaluation.evaluation_type_id === 3) {
                this.$router.push('/avaliacao/listar')
              }
            })
          }).catch(swal.noop)
        } else {
          swal({
            title: 'Atenção!',
            text: 'Você não finalizou a avaliação. Responda todas as competências!',
            type: 'warning',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          }).then(() => {
            this.scrollWinTop()
          })
        }
      },
      sendEvaluationAnswer () {
        let url = '/collaborator/manager/collaborator-evaluation-answer'
        return axios.post(url, { token: this.token, evaluationAnswers: this.evaluationAnswers, evaluationDeliveryAnswer: this.evaluationDeliveryAnswer, evaluationOpenAnswer: this.evaluationOpenAnswer })
      },
      scrollWinTop () {
        $('.main-panel').scrollTop(250, 0)
      },
      handleClose (tag) {
        this.tags.dynamicTags.splice(this.tags.dynamicTags.indexOf(tag), 1)
      },
      showInput () {
        this.tags.inputVisible = true
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus()
        })
      },

      handleInputConfirm () {
        let inputValue = this.tags.inputValue
        if (inputValue) {
          this.tags.dynamicTags.push(inputValue)
        }
        this.tags.inputVisible = false
        this.tags.inputValue = ''
      }
    },
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      }
    }
  }
</script>
<style>
  .view-block {
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 1060;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.8);
    padding: .625em;
    overflow-x: hidden;
    font-size: 8rem;
  }

  .lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }

  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid rgb(8, 8, 8);
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: rgb(8, 8, 8) transparent transparent transparent;
  }

  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }

  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .extended-forms .el-select {
    width: 100%;
    margin-bottom: 30px;
  }

  .title_h5{
  line-height: 0.4em;
  }
  .name_member{
  text-align:left;
  margin-top:-2px;
  }
  .img_member img {
    max-width: 140%;
    height: auto;
  }
  .select-default.el-select .el-input .el-input__icon {
    border-radius: 20px;
    height: auto;
}
.card h6 {
    font-size: 12px;
    margin: 0px 0 8px 0px;
}
.extended-forms .el-select {
    width: 100%;
    margin-bottom: 21px;
}
.bt-comp-c{
  margin-top: -5px;
  font-size:10px;
}
.bt-end{
  width:100%;
}

.img_member img {
    max-width: 45%;
    height: auto;
}

.name_member {
    text-align: left;
    margin-top: -2px;
    font-size: 20px;
}

@media screen and (max-width: 480px) {
    .img_member img {
    max-width: 140%;
    height: auto;
}

.name_member {
    text-align: left;
    margin-top: -2px;
    font-size: 12px;
}
}


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Manager/Evaluation/Form.vue